<!-- Voice Recording UI Container -->
<div class="flex items-center justify-between w-full px-4 py-2shadow-sm">
  <!-- Left side controls -->
  <div class="flex items-center gap-3">
    
    <!-- Microphone indicator -->
    <app-button [fullWidth]="true" icon="pi pi-microphone" iconSource="primeng" iconSize="default"
    variant="outlined" severity="contrast" 
    styleClass="option-button" />
  </div>
  
  <!-- Center: Waveform visualization -->
  <div #waveformContainer class="flex-1 mx-4 flex items-center gap-[2px] h-12 overflow-hidden">
    @for (height of waveformBars(); track $index) {
      <div 
        class="waveform-bar transition-all duration-100"
        [style.height.%]="height">
      </div>
    }
  </div>
  
  <!-- Timer display -->
  <div class="text-gray-600 font-medium text-base mr-4 min-w-[3rem] text-right">
    {{ elapsedTime() }}
  </div>
  
  <!-- Right side controls -->
  <div class="flex items-center gap-2">
      <!-- Cancel button -->
      <app-button
        icon="pi pi-times"
        iconSource="primeng"
        iconSize="default"
        variant="outlined"
        severity="contrast"
        (clicked)="onCancel()">
      </app-button>
      
      <!-- Confirm button -->
      <app-button
        icon="pi pi-check"
        iconSource="primeng"
        iconSize="default"
        variant="filled"
      severity="success" (clicked)="onConfirm()">
    </app-button>
  </div>
</div>
